import { PlanSubmissionStatus } from '@ebalance/proto/bfftypes/v1/plan_submission_pb'

/**
 * XML ダウンロードボタンの活性判定 (AC-13)。
 *
 * SUBMIT_FAILED / SEND_FAILED は活性 (提出起因の失敗 = XML は作成時に生成済み)。SUBMITTING も
 * 活性 (処理中 = XML は作成時生成済みで、既存の GENERATED 活性規則と一貫)。
 * GENERATION_FAILED / GENERATING / EDITING は非活性のまま (XML 未生成)。
 *
 * 注: GENERATED / SUBMIT_FAILED / SEND_FAILED / SUBMITTING / APPROVAL_PENDING の
 * 5 状態の DL 活性定義は #2746 の確定対象。spec AC-027 と AC-PGL-021 では
 * 非活性、または状態自体が未定義のため、確定後に追従する (設計書 §5 参照)。
 */
export function canDownloadXml(status: PlanSubmissionStatus): boolean {
  return (
    status === PlanSubmissionStatus.GENERATED ||
    status === PlanSubmissionStatus.SUBMITTED ||
    status === PlanSubmissionStatus.ACCEPTED ||
    status === PlanSubmissionStatus.REJECTED ||
    status === PlanSubmissionStatus.INCONSISTENT ||
    status === PlanSubmissionStatus.SUBMIT_FAILED ||
    status === PlanSubmissionStatus.SEND_FAILED ||
    status === PlanSubmissionStatus.SUBMITTING ||
    status === PlanSubmissionStatus.APPROVAL_PENDING
  )
}
